import * as React from "react";

export type SectionHeaderProps = React.HTMLAttributes<HTMLDivElement> & {
  label?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  action?: React.ReactNode;
};

export const SectionHeader = React.forwardRef<HTMLDivElement, SectionHeaderProps>(
  ({ className = "", label, title, subtitle, action, ...props }, ref) => {
    return (
      <div ref={ref} className={`flex flex-col gap-3 ${className}`} {...props}>
        <div className="flex items-start justify-between gap-4">
          <div>
            {label && (
              <p className="text-xs uppercase tracking-[0.4em] text-gray-400 font-bold mb-2">{label}</p>
            )}
            <h2 className="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-slate-900 to-slate-700">{title}</h2>
          </div>
          {action && <div className="flex-shrink-0">{action}</div>}
        </div>
        {subtitle && <p className="text-base text-slate-600">{subtitle}</p>}
      </div>
    );
  }
);

SectionHeader.displayName = "SectionHeader";
